import { APIClient } from "./api_helper";
import * as url from "./realtime_url_helper";

const api = new APIClient();

export const postLogin = (data: any) => api.create(url.Login, data);
export const postSignUp = (data: any) => api.create(url.Signup, data);
export const postCreateTenant = (data: any) => api.create(url.CreateTenant, data);
export const getAllTenant = (page: number, count: number, keyword?: string) =>
  api.get(url.getAllTenant, { keyword: keyword, page: page, count: count });
export const getTenantById = (id: string) => api.get(url.getTenantById, { id });
export const getTenantAppConfig = (tenantId?: string) =>
  api.get(url.getTenantAppConfig, tenantId ? { tenantId } : {});
export const updateTenant = (data: any) => api.put(url.updateTenant, data);
export const deleteTenantById = (id: string) => api.delete(`${url.deleteTenant}?id=${id}`);
export const getUserById = (id: string) =>
  api.get(`${url.getUserById}`, { id: id });
export const getAllUser = (page: number, count: number, keyword?: string) =>
  api.get(url.getAllUser, { keyword: keyword, page: page, count: count });
export const addUser = (data: any) => api.create(url.addUser, data);
export const updateUser = (data: any) => api.put(url.updateUser, data);
export const changePassword = (data: any) => api.put(url.changePassword, data);

export const getAllVehicle = (page: number, count: number, keyword?: string) =>
  api.get(`${url.getAllVehicle}`, {
    keyword: keyword,
    page: page,
    count: count,
  });

export const getAllVehicleGroup = (
  page: number,
  count: number,
  keyword: string
) =>
  api.get(`${url.getAllVehicleGroup}`, {
    keyword: keyword,
    page: page,
    count: count,
  });
export const getAllDriver = (page: number, count: number, keyword: string) =>
  api.get(`${url.getAllDriver}`, {
    keyword: keyword,
    page: page,
    count: count,
  });
export const getAllBooking = (
  page: number,
  count: number,
  keyword: string,
  status: string,
  driverId?: string,
  startDate?: number,
  endDate?: number
) => {
  const params: any = {
    keyword: keyword,
    page: page,
    count: count,
    status: status,
  };
  if (driverId) {
    params.driverId = driverId;
  }
  if (startDate) {
    params.startDate = startDate;
  }
  if (endDate) {
    params.endDate = endDate;
  }
  return api.get(`${url.getAllBooking}`, params);
};

export const getAllCustomer = (
  page: number,
  count: number,
  keyword: string,
  status: string,
  companyId?: string
) => {
  const params: any = {
    keyword: keyword,
    page: page,
    count: count,
    status: status,
  };
  if (companyId) {
    params.companyId = companyId;
  }
  return api.get(`${url.getAllCustomer}`, params);
};

export const getAllMaintenance = (
  page: number,
  count: number,
  keyword: string
) =>
  api.get(`${url.getAllMaintenance}`, {
    keyword: keyword,
    page: page,
    count: count,
  });

export const getAllInventory = (
  page: number,
  count: number,
  keyword?: string
) =>
  api.get(`${url.getAllInventory}`, {
    keyword: keyword,
    page: page,
    count: count,
  });
export const getAllFuel = (page: number, count: number, keyword?: string) =>
  api.get(`${url.getAllFuel}`, { keyword: keyword, page: page, count: count });

export const getAllReminder = (page: number, count: number, keyword?: string) =>
  api.get(`${url.getAllReminder}`, {
    keyword: keyword,
    page: page,
    count: count,
  });

export const getAllIncomeAndExpenses = (
  page: number,
  count: number,
  keyword?: string
) =>
  api.get(`${url.getAllIncomeAndExpenses}`, {
    keyword: keyword,
    page: page,
    count: count,
  });

export const addVehicle = (data: any) => api.create(url.addVehicle, data);
export const addVehicleGroup = (data: any) =>
  api.create(url.addVehicleGroup, data);
export const updateVehicle = (data: any) => api.put(url.updateVehicle, data);
export const getVehicleById = (id: string) =>
  api.get(`${url.getVehicleById}`, { id: id });
export const deleteVehicleById = (id: any) =>
  api.delete(`${url.deleteVehicleById}id=${id}`);
export const deleteVehicleGroup = (id: any) =>
  api.delete(`${url.deleteVehicleById}id=${id}`);
export const getAllDashboardCount = () => api.get(url.getAllDashboardCount, {});

export const addDriver = (data: any) => api.create(url.addDriver, data);
export const updateDriver = (data: any) => api.put(url.updateDriver, data);
export const getDriverById = (id: string) =>
  api.get(`${url.getDriverById}`, { id: id });
export const deletedDriver = (id: string) =>
  api.delete(`${url.deleteDriver}?id=${id}`);

export const addCustomer = (data: any) => api.create(url.addCustomer, data);
export const updateCustomer = (data: any) => api.put(url.updateCustomer, data);
export const getCustomerById = (id: string) =>
  api.get(`${url.getCustomerById}`, { id: id });
export const deleteCustomerById = (id: string) =>
  api.delete(`${url.deleteCustomerById}id=${id}`);

export const addInventory = (data: any) => api.create(url.addInventory, data);
export const updateInventory = (data: any) =>
  api.update(url.updateInventory, data);
export const getInventoryById = (id: string) =>
  api.get(`${url.getInventoryById}`, { id: id });
export const deleteInventoryById = (id: any) =>
  api.delete(`${url.deleteInventoryById}id=${id}`);
export const addFuel = (data: any) => api.create(url.addFuel, data);
export const updateFuel = (data: any) => api.update(url.updateFuel, data);
export const getFuelById = (id: string) =>
  api.get(`${url.getFuelById}`, { id: id });
export const deleteFuelById = (id: any) =>
  api.delete(`${url.deleteFuelById}=${id}`);
export const addReminder = (data: any) => api.create(url.addReminder, data);
export const updateReminder = (data: any) =>
  api.update(url.updateReminder, data);
export const getReminderById = (id: string) =>
  api.get(`${url.getReminderById}${id}`, {});
export const deleteReminderById = (id: any) =>
  api.delete(`${url.deleteReminderById}?id=${id}`);
export const addIncomeAndExpenses = (data: any) =>
  api.create(url.addIncomeAndExpenses, data);
export const updateIncomeAndExpenses = (data: any) =>
  api.update(url.updateIncomeAndExpenses, data);
export const getIncomeAndExpensesById = (id: string) =>
  api.get(`${url.getIncomeAndExpensesById}/${id}`, {});
export const deleteIncomeAndExpensesById = (id: any) =>
  api.delete(`${url.deleteIncomeAndExpensesById}?id=${id}`);
export const addMaintenance = (data: any) =>
  api.create(url.addMaintenance, data);
export const updateMaintenance = (data: any) =>
  api.put(url.updateMaintenance, data);
export const updateStatusMaintenance = (id: string, status: string) =>
  api.update(`${url.updateStatusMaintenance}?id=${id}&status=${status}`, {});
export const getMaintenanceById = (id: string) =>
  api.get(`${url.getMaintenanceById}/id`, { id: id });
export const deleteMaintenanceById = (id: any) =>
  api.delete(`${url.deleteMaintenanceById}?id=${id}`);

export const addBooking = (data: any) => api.create(url.addBooking, data);
export const updateBooking = (data: any) => api.update(url.updateBooking, data);
export const getBookingById = (id: string) =>
  api.get(`${url.getBookingById}`, { id: id });
export const deleteBookingById = (id: any) =>
  api.delete(`${url.deleteBookingById}?id=${id}`);
export const getAllBookingVehicleById = (
  page: number,
  count: number,
  id: string,
  keyword?: string
) =>
  api.get(`${url.getAllBookingVehicleById}`, {
    id: id,
    page: page,
    count: count,
    keyword: keyword,
  });
export const getIncomeByVehicleId = (
  page: number,
  count: number,
  id: string,
  keyword?: string
) =>
  api.get(`${url.getIncomeByVehicleId}`, {
    id: id,
    page: page,
    count: count,
    keyword: keyword,
  });

export const addPayment = (data: any) => api.create(url.addPayment, data);
export const getPaymentByBookingId = (id: string) =>
  api.get(`${url.getPaymentByBookingId}`, { id: id });
export const deletePaymentById = (id: any) =>
  api.delete(`${url.deletePayment}/${id}`);
export const updateBookingStatus = (bookingId: string, tripStatus: string) =>
  api.put(
    `${url.updateBookingStatusbyId}?bookingId=${bookingId}&tripStatus=${tripStatus}`,
    {}
  );
export const addCompany = (data: any) => api.create(url.addCompany, data);
export const updateCompany = (data: any) => api.put(url.updateCompany, data);
export const getAllCompany = (
  page: number,
  count: number,
  keyword: string,
  status: string
) =>
  api.get(`${url.getCompany}`, {
    page: page,
    count: count,
    keyword: keyword,
    status: status,
  });
export const deleteCompanyById = (id: string) =>
  api.delete(`${url.deleteCompanyById}?companyId=${id}`, {});
export const getCompanyById = (id: string) =>
  api.get(`${url.getCompanyById}`, { companyId: id });

export const getBookingByCompanyId = (
  companyId: string,
  tripStatus: string,
  page: number,
  count: number,
  allRideSearch :string
) =>
  api.get(`${url.getBookingByCompanyId}`, {
    companyId: companyId,
    tripStatus: tripStatus,
    page: page,
    count: count,
    keyword:allRideSearch
  });

export const getCustomerByCompanyId = (
  companyId: string,
  page: number,
  keyword:string,
  count: number
) =>
  api.get(`${url.getCustomerByCompanyId}`, {
    companyId: companyId,
    page: page,
    count: count,
    keyword: keyword,
  });


export const addCustomerInCompanyId = (data: any) =>
  api.put(`${url.addCustomerInCompany}`, data,);


export const AssignChildCompanyId = (data:any) =>
  api.put(`${url.childAssign}`, data);